import {GameObjectsTags} from '../../../ClickerGame.constants';
import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {BaseComponent} from '@specials/gcs-engine';

import {LocationType} from '@/services/ProjectAuthApi/types';
import {UserStore} from '@/stores/UserStore/UserStore';

export interface IBackgroundGalaxyDataComponent extends BaseComponent {
  locationType: LocationType;
}

export class BackgroundGalaxyDataComponent extends BaseComponent implements IBackgroundGalaxyDataComponent {
  public locationType: LocationType;
  public tag = GameObjectsTags.BackgroundDataComponent;

  constructor(private readonly userStore: UserStore) {
    super();
  }

  public onAddToGameObject(): void {
    this.locationType = this.userStore.getLocationType();
  }
}

injected(BackgroundGalaxyDataComponent, DI_TOKENS.userStore);
